import { useLayoutEffect, useRef, type RefObject } from "react";

interface ExclusiveOverlayHandle {
    close: () => void;
    unmount: () => void;
}

const listeners = new Set<() => void>();

export const dismissLightOverlays = (): void => {
    listeners.forEach((listener) => {
        listener();
    });
};

export const subscribeLightDismiss = (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

export const useCloseOnExclusiveOverlay =
    (): RefObject<ExclusiveOverlayHandle | null> => {
        const actionsRef = useRef<ExclusiveOverlayHandle | null>(null);

        useLayoutEffect(() => {
            function closeOnExclusiveOverlay() {
                actionsRef.current?.close();
            }

            return subscribeLightDismiss(closeOnExclusiveOverlay);
        }, []);

        return actionsRef;
    };
